import { cn } from '@lyearn/style';
import { ResourceStatusEnum, VersionConfig } from '@/types/schema';

import { publishedChangesStyles, unpublishedChangesStyles } from './styles';

export const getMenuItems = (versionConfigs: VersionConfig[]) => {
  return [
    {
      id: versionConfigs.find((item) => item.status === ResourceStatusEnum.Draft)?.rootBlockId,
      title: 'Admin:Preview.UnpublishedChanges',
    },
    {
      id: versionConfigs.find((item) => item.status === ResourceStatusEnum.Published)?.rootBlockId,
      title: 'Admin:Preview.Published',
    },
  ];
};

export const LABEL_CONFIG = {
  [ResourceStatusEnum.Draft]: {
    label: 'Admin:Status.UNPUBLISHED_CHANGES',
    icon: 'icon-purple',
    labelClassNames: cn(
      'text-text-purple active:text-text-purple-dark bg-bg-purple-light',
      unpublishedChangesStyles,
    ),
  },
  [ResourceStatusEnum.Published]: {
    label: 'Common:Filter.Published',
    icon: 'icon-primary',
    labelClassNames: cn(
      'text-text-secondary active:text-text-primary bg-bg-tertiary',
      publishedChangesStyles,
    ),
  },
};
